import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AuthModule } from '®shared/auth';

import { TarlV3Api } from './tarl-v3-api.service';

@NgModule({
  imports: [CommonModule, AuthModule, HttpClientModule],
  providers: [TarlV3Api],
})
export class TarlV3ApiModule {}
